<template>
  <div id="ExternalGuestRegistration" class="fullheight bg-light">
    <CContainer v-if="event" fluid class="fullheight px-0">
      <CRow class="fullheight no-gutters">
        <!-- Columna izquierda: Imagen o Info -->
        <CCol md="6" class="left-column d-flex align-items-center justify-content-center">
          <div class="content-wrapper text-center p-4">
            <!-- Imagen -->
            <img
              v-if="isImage"
              :src="event.image"
              alt="Invitación"
              class="event-image"
            />

            <!-- PDF -->
            <div
              v-else-if="isPdf"
              class="pdf-placeholder d-flex flex-column align-items-center justify-content-center bg-white shadow-sm rounded p-5"
            >
              <h3><strong> {{event.name}}</strong></h3>
              <p class="display-4 mb-3">📄</p>
              <p class="font-weight-bold mb-2">Invitación en PDF</p>
              <p class="text-muted mb-3">Descárgala para verla completa</p>

              <CButton color="info">
                Descargar invitación
              </CButton>
            </div>
            <!-- Fallback -->
            <div v-else class="event-info text-left p-4 rounded bg-white shadow-sm" style="max-width: 500px;">
              <h2 class="mb-3">{{ event.name }}</h2>

              <p class="mb-1">
                <strong>📅 Fecha:</strong> {{ formattedDate }}
              </p>
              <p class="mb-1" v-if="event.start_hour && event.end_hour">
                <strong>🕒 Hora:</strong> {{ event.start_hour }} - {{ event.end_hour }}
              </p>
              <p class="mb-1" v-if="event.address">
                <strong>📍 Lugar:</strong> {{ event.address }}
              </p>

              <p class="mt-3" v-if="event.description">
                {{ event.description }}
              </p>

              <p class="text-muted mt-4" v-if="event.planner_name">
                Organiza: {{ event.planner_name }}
              </p>
            </div>

          </div>
        </CCol>

        <!-- Columna derecha: Formulario -->
        <CCol md="6" class="right-column d-flex align-items-center justify-content-center">
          <div class="form-container bg-white shadow p-5 rounded" style="width: 100%; max-width: 450px;">
            <div class="text-center mb-3">
              <img src="logo_confirmame.png" alt="Logo Confirmame" class="logo-img" />
            </div>

            <template v-if="!isRegistered">
              <h3 class="mb-4 text-center">Registro de Invitado</h3>

              <CInput v-model="form.name" label="Nombre completo" placeholder="Tu nombre completo" class="mb-3" />

              <CInput v-model="form.tickets" label="Cantidad de acompañantes" min="0" :max="event.max_tickets"
                placeholder="Ej. 2" class="mb-3" />

              <CInput v-if="event.contact_method === 'email'" v-model="form.email" label="Correo electrónico"
                placeholder="nombre@correo.com" class="mb-3" />

              <CInput v-if="event.contact_method === 'phone'" v-model="form.phone" label="Número de WhatsApp"
                placeholder="Ej. 5551234567" class="mb-4" />

              <CButton color="info" class="w-100" @click="submit">
                Registrarme
              </CButton>
            </template>
            <template v-else>
              <h3 class="mb-3 text-success">🎉 ¡Registro exitoso!</h3>
              <p class="text-muted mb-4">Te hemos enviado tu pase con código QR al contacto proporcionado.</p>
              <p class="font-weight-bold">Nos vemos el <span>{{ formattedDate }}</span></p>
            </template>
          </div>
        </CCol>
      </CRow>
    </CContainer>
    <loading :active="visible" :can-cancel="true" loader="bars"></loading>
    <CToaster placement="top-end">
      <template>
        <CToast v-for="(toast, key) in toasts" :color="toast.color" v-bind="toast" :key="'toast' + key" :show="true">
          {{ toast.content }}
        </CToast>
      </template>
    </CToaster>
  </div>
</template>

<script>
import eventsService from "@/services/events";
import router from "@/router";
import store from '../../store'
import Loading from 'vue-loading-overlay/dist/vue-loading.js';
import 'vue-loading-overlay/dist/vue-loading.css';
import axios from 'axios'

export default {
  name: "ExternalGuestRegistration",
  data() {
    return {
      event: null,
      isRegistered: false,
      form: {
        name: "",
        tickets: 0,
        email: "",
        phone: ""
      }
    };
  },
  components: {
    Loading
  },
  async created() {
    await this.loadEvent();
  },
  computed: {
    isPdf() {
      return this.event?.image?.toLowerCase().endsWith('.pdf')
    },
    isImage() {
      return this.event?.image && !this.isPdf
    },
    formattedDate() {
      const options = { year: 'numeric', month: 'long', day: 'numeric' };
      return new Date(this.event.date).toLocaleDateString('es-MX', options);
    },
    visible() {
      return store.state.isLoading;
    },
    toasts() {
      return store.state.toasts;
    },
  },
  methods: {
    async loadEvent() {
      try {
        const slug = this.$route.params.event_slug;
        const code = this.$route.params.code;

        const response = await eventsService.getExternalEvent(slug, code);

        if (response.data && response.type === "success") {
          this.event = response.data;
        } else {
          router.push({ name: "404" });
        }
      } catch (error) {
        router.push({ name: "404" });
      }
    },
    async submit() {
      this.loading();
      try {
        const payload = {
          event_id: this.event.id,
          name: this.form.name,
          tickets: this.form.tickets,
          email: this.form.email,
          phone: this.form.phone,
        };

        const response = await eventsService.storeExternalGuest(payload);

        if (response.data && response.type === "success") {
          // Registro exitoso
          this.showToast("success", "Registro exitoso. ¡Gracias por confirmar tu asistencia!");
          this.isRegistered = true;
        } else {
          // Error del backend
          this.showToast("error", response.message);
        }
      } catch (error) {
        console.error("Error al registrar invitado:", error);
        this.showToast("error", "Ocurrió un error al registrar. Intenta más tarde.");
      }
      this.loaded();
    },
    resetForm() {
      this.form = {
        name: "",
        tickets: 0,
        email: "",
        phone: ""
      };
    },
    showToast(type, message) {
      store.commit('toast', { color: type, message: message });
    },
    loading() {
      store.commit('loading');
    },
    loaded() {
      store.commit('loaded');
    }
  }
};
</script>

<style scoped>
.fullheight {
  min-height: 100vh;
}

.bg-light {
  background-color: #f7f0e6;
}

.left-column {
  background-color: #f7f0e6;
  padding: 2rem;
  text-align: center;
}

.right-column {
  background-color: #f7f0e6;
  padding: 2rem;
}

.event-image {
  max-height: 600px;
  max-width: 100%;
  object-fit: contain;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.event-info h2 {
  font-size: 2rem;
  font-weight: bold;
  margin-bottom: 1rem;
}

.event-info p {
  font-size: 1rem;
  color: #555;
}

.event-info {
  font-size: 1rem;
  color: #333;
}

.event-info strong {
  color: #000;
}


.logo-img {
  width: 180px;
  max-width: 100%;
  margin: auto;
  display: block;
}

.pdf-placeholder {
  max-width: 500px;
  width: 100%;
  min-height: 400px;
  text-align: center;
}
</style>
